module.exports = __webpack_public_path__ + "img/l_h6.03eb5fe3.png";